<div *ngIf="report">
	<div class="row mb-3">
		<div class="col-6">
			<h4 class="mb-0">Product sales</h4>
		</div>
		<div class="col-6 text-right">
			<form class="form-inline justify-content-end">
				<select class="form-control" [(ngModel)]="selectedMonth" [ngModelOptions]="{standalone: true}" (ngModelChange)="updateReport()">
					<option *ngFor="let month of months" [value]="month">{{month}}</option>
				</select>
				<select class="form-control ml-3" [(ngModel)]="selectedYear" [ngModelOptions]="{standalone: true}" (ngModelChange)="updateReport()">
					<option *ngFor="let year of years" [value]="year">{{year}}</option>
				</select>
			</form>
		</div>
	</div>

	<div class="text-center text-danger" *ngIf="report.items.length === 0">
		No product sales found for this month.
	</div>

	<div *ngIf="report.items.length > 0">
		<table class="table table-sm table-striped table-borderless text-right">
			<thead>
			<tr>
				<th class="text-left">Date</th>
				<th class="text-left">Studio</th>
				<th class="text-left">Product</th>
				<th>Qty</th>
				<th>Gross</th>
				<th>Discount</th>
				<th>Ex VAT</th>
				<th>VAT</th>
				<th>Inc VAT</th>
			</tr>
			</thead>
			<tbody>
			<tr *ngFor="let item of report.items">
				<td class="text-left text-monospace">{{item.saleDate | date:'dd-MM-yyyy'}}</td>
				<td class="text-left">{{item.studio?.name}}</td>
				<td class="text-left">{{item.productName}}</td>
				<td>{{item.quantity}}</td>
				<td>{{item.grossAmount | currency:'EUR'}}</td>
				<td>{{item.discountAmount | currency:'EUR'}}</td>
				<td>{{item.totalExVat | currency:'EUR'}}</td>
				<td>{{item.totalVat | currency:'EUR'}}</td>
				<td><strong>{{item.totalIncVat | currency:'EUR'}}</strong></td>
			</tr>
			</tbody>
			<tfoot>
			<tr class="font-weight-bold">
				<td colspan="3" class="text-left">Total</td>
				<td>{{report.totalQuantity}}</td>
				<td>{{report.totalGrossAmount | currency:'EUR'}}</td>
				<td>{{report.totalDiscountAmount | currency:'EUR'}}</td>
				<td>{{report.totalExVat | currency:'EUR'}}</td>
				<td>{{report.totalVat | currency:'EUR'}}</td>
				<td>{{report.totalIncVat | currency:'EUR'}}</td>
			</tr>
			</tfoot>
		</table>
	</div>
</div>
